import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

function CarouselFifa() {
  return (
    <Carousel>
      <div>
        <img
          src="img/Graphics/01.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 02"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/02.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 02"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/03.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 03"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/04.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 04"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/05.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 05"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/06.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 06"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/07.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 07"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/08.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 08"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/09.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 09"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/10.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 10"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/11.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 11"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/12.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 12"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/13.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 13"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/14.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 14"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/15.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 15"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/16.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 16"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/17.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 17"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/18.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 18"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/19.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 19"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/20.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 20"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/21.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 21"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/22.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 22"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/23.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 23"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/24.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 24"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/25.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 25"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/26.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 26"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/27.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 27"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/28.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 28"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/29.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 29"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/30.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 30"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/31.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 31"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>
      <div>
        <img
          src="img/Graphics/32.jpg"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Graphics 32"
          id="imgCarousel"
        />
        <p className="legend">Graphics, Logo, Website</p>
      </div>




<div>
  <img
    src="img/Websites/01.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 01"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/02.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 02"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/03.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 03"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/04.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 04"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/05.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 05"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/06.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 06"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/07.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 07"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/08.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 08"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>
<div>
  <img
    src="img/Websites/09.jpg"
    className="w-100 shadow-1-strong rounded mb-4"
    alt="Website 09"
    id="imgCarousel"
  />
  <p className="legend">Website</p>
</div>






      {/* Imágenes mockupSophie */}
      <div>
        <img
          src="img/Graphics/mockupSophie-02.png"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Computer view of the website"
          id="imgCarousel"
        />
        <p className="legend">Computer view of the website</p>
      </div>
      <div>
        <img
          src="img/Graphics/mockupSophie-01.png"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Phone view of the website"
          id="imgCarousel"
        />
        <p className="legend">Phone view of the website</p>
      </div>
      <div>
        <img
          src="img/Graphics/mockupSophie-03.png"
          className="w-100 shadow-1-strong rounded mb-4"
          alt="Contact Form"
          id="imgCarousel"
        />
        <p className="legend">Contact Form</p>
      </div>
    </Carousel>
  );
}

export default CarouselFifa;
